import { useState, useEffect, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { api } from '../services/api';
import { Spinner } from '../components/UI';
import logo from '../assets/logo_brandstarter.png';

const css = `
  .ad { --g:#173B34; --o:#E4572E; --c:#F6F2EC; --line:#E3DCCF; --mut:#6b6b64;
    font-family: 'Inter', system-ui, -apple-system, sans-serif; background: var(--c); min-height: 100vh; min-height: 100dvh; color: #222; }
  .ad-top { background: #fff; border-bottom: 1px solid var(--line); height: 60px; display: flex; align-items: center; justify-content: space-between; padding: 0 16px; position: sticky; top: 0; z-index: 50; }
  .ad-top img { height: 30px; width: auto; display: block; }
  .ad-pill-admin { background: var(--g); color: #fff; font-size: 11px; font-weight: 700; border-radius: 999px; padding: 5px 12px; letter-spacing: .04em; }
  .ad-grid { display: block; }
  .ad-pane { padding: 16px 16px 24px; }
  .ad-h2 { font-family: inherit; font-size: 24px; color: var(--g); font-weight: 800; margin: 0 0 14px; letter-spacing: -0.01em; }
  .ad-kpis { display: grid; grid-template-columns: 1fr 1fr; gap: 10px; margin-bottom: 14px; }
  .ad-card { background: #fff; border: 1px solid var(--line); border-radius: 18px; padding: 14px; }
  .ad-kpi b { display: block; font-size: 28px; line-height: 1; color: var(--g); font-weight: 800; }
  .ad-kpi span { font-size: 12.5px; color: var(--mut); }
  .ad-kpi.hot b { color: var(--o); }
  .ad-search { width: 100%; height: 50px; border: 1.5px solid var(--line); background: #fff; border-radius: 14px; padding: 0 16px; font-size: 16px; font-family: inherit; outline: none; -webkit-appearance: none; }
  .ad-search:focus { border-color: var(--g); }
  .ad-chips { display: flex; gap: 8px; overflow-x: auto; padding: 12px 0 4px; scrollbar-width: none; }
  .ad-chips::-webkit-scrollbar { display: none; }
  .ad-chip { flex: 0 0 auto; min-height: 44px; padding: 0 16px; border-radius: 999px; border: 1.5px solid var(--line); background: #fff; color: var(--g); font-weight: 600; font-size: 14px; font-family: inherit; cursor: pointer; }
  .ad-chip.on { background: var(--g); border-color: var(--g); color: #fff; }
  .ad-list { margin-top: 10px; }
  .ad-u { display: flex; gap: 12px; align-items: center; padding: 13px; margin-bottom: 9px; cursor: pointer; width: 100%; text-align: left; font-family: inherit; color: inherit; }
  .ad-u.sel { border-color: var(--g); box-shadow: 0 0 0 2px rgba(23,59,52,.12); }
  .ad-ini { width: 44px; height: 44px; border-radius: 50%; background: var(--g); color: #fff; font-weight: 800; font-size: 14px; display: flex; align-items: center; justify-content: center; flex: 0 0 auto; }
  .ad-ini.prem { background: var(--o); } .ad-ini.off { background: #b9a98e; }
  .ad-u-body { flex: 1; min-width: 0; }
  .ad-u-row { display: flex; justify-content: space-between; align-items: center; gap: 8px; }
  .ad-u-name { font-size: 15px; font-weight: 700; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
  .ad-u-meta { font-size: 13px; color: var(--mut); margin-top: 2px; }
  .ad-bar { height: 6px; border-radius: 99px; background: #e6dfd2; overflow: hidden; margin-top: 7px; }
  .ad-bar i { display: block; height: 100%; background: var(--o); border-radius: 99px; }
  .ad-st { font-size: 11px; font-weight: 700; border-radius: 999px; padding: 3px 10px; white-space: nowrap; flex: 0 0 auto; }
  .ad-st.actif { background: #dcefe5; color: var(--g); } .ad-st.premium { background: #fde6de; color: var(--o); }
  .ad-st.bloque { background: #f1d4cf; color: #9b2c1f; } .ad-st.expire { background: #eee; color: #666; } .ad-st.soon { background: #fff1cf; color: #8a6200; }
  .ad-fab { position: fixed; right: 16px; bottom: calc(86px + env(safe-area-inset-bottom)); min-height: 54px; padding: 0 22px; border-radius: 27px; border: 0; background: var(--o); color: #fff; font-weight: 700; font-size: 15px; font-family: inherit; box-shadow: 0 8px 20px rgba(228,87,46,.4); cursor: pointer; z-index: 40; }
  .ad-empty { text-align: center; color: var(--mut); padding: 36px 16px; font-size: 15px; }

  /* FICHE */
  .ad-detail { display: none; }
  .ad-detail.open { display: block; position: fixed; inset: 0; z-index: 120; background: var(--c); overflow-y: auto; -webkit-overflow-scrolling: touch; }
  .ad-d-top { position: sticky; top: 0; background: #fff; border-bottom: 1px solid var(--line); height: 60px; display: flex; align-items: center; gap: 6px; padding: 0 8px; z-index: 2; }
  .ad-back { background: none; border: 0; width: 48px; height: 48px; font-size: 26px; color: var(--g); cursor: pointer; }
  .ad-d-title { font-weight: 800; font-size: 17px; color: var(--g); }
  .ad-d-body { padding: 16px 16px 40px; max-width: 640px; margin: 0 auto; }
  .ad-sec { font-size: 12px; font-weight: 700; color: var(--g); text-transform: uppercase; letter-spacing: .08em; margin: 20px 0 8px; }
  .ad-id { display: flex; gap: 14px; align-items: center; }
  .ad-id .ad-ini { width: 54px; height: 54px; font-size: 16px; }
  .ad-mail { font-size: 14px; color: var(--mut); word-break: break-all; }
  .ad-row2 { display: grid; grid-template-columns: 1fr 1fr; gap: 10px; }
  .ad-stat { background: #fff; border: 1px solid var(--line); border-radius: 14px; padding: 12px; }
  .ad-stat b { display: block; font-size: 17px; color: var(--g); } .ad-stat span { font-size: 12px; color: var(--mut); }
  .ad-btn { display: flex; align-items: center; justify-content: center; min-height: 50px; border-radius: 14px; border: 1.5px solid transparent; font-weight: 700; font-size: 15px; font-family: inherit; cursor: pointer; width: 100%; padding: 0 14px; }
  .ad-btn.pri { background: var(--o); color: #fff; } .ad-btn.green { background: var(--g); color: #fff; }
  .ad-btn.ghost { background: #fff; border-color: var(--line); color: var(--g); } .ad-btn.red { background: #fff; border-color: #f1c3b8; color: #b8391a; }
  .ad-btn:disabled { opacity: .6; }
  .ad-in { width: 100%; height: 50px; border: 1.5px solid var(--line); background: #fff; border-radius: 14px; padding: 0 14px; font-size: 16px; font-family: inherit; outline: none; -webkit-appearance: none; appearance: none; color: #222; }
  .ad-in:focus { border-color: var(--g); }
  textarea.ad-in { height: 84px; padding: 12px 14px; resize: none; line-height: 1.4; }
  .ad-qk { display: flex; gap: 8px; margin: 10px 0; overflow-x: auto; scrollbar-width: none; }
  .ad-small { font-size: 13px; color: var(--mut); line-height: 1.45; margin: 0 0 8px; }
  .ad-resp { background: #fff; border-left: 4px solid var(--g); border-radius: 0 14px 14px 0; padding: 12px 14px; margin-bottom: 10px; }
  .ad-resp b { font-size: 12px; color: var(--mut); letter-spacing: .05em; text-transform: uppercase; }
  .ad-resp p { font-size: 14px; line-height: 1.55; white-space: pre-wrap; margin: 4px 0 0; }

  /* JOURNAL */
  .ad-ev { display: flex; gap: 12px; padding: 13px 0; border-bottom: 1px solid var(--line); }
  .ad-dot { width: 10px; height: 10px; border-radius: 50%; background: var(--o); margin-top: 6px; flex: 0 0 auto; }
  .ad-ev b { font-size: 14.5px; display: block; } .ad-ev p { font-size: 13px; color: var(--mut); margin: 2px 0 0; }
  .ad-ev em { font-size: 13px; color: #555; display: block; margin-top: 3px; }

  /* BARRE DU BAS */
  .ad-bn { position: fixed; left: 0; right: 0; bottom: 0; z-index: 100; display: flex; background: #fff; border-top: 1px solid var(--line); padding-bottom: env(safe-area-inset-bottom); }
  .ad-bn button { flex: 1; min-width: 0; min-height: 66px; background: none; border: 0; font-family: inherit; font-size: 10.5px; font-weight: 600; color: #8a8a82; display: flex; flex-direction: column; align-items: center; justify-content: center; gap: 4px; cursor: pointer; }
  .ad-bn button svg { width: 24px; height: 24px; stroke: currentColor; fill: none; stroke-width: 1.8; stroke-linecap: round; stroke-linejoin: round; }
  .ad-bn button.on { color: var(--o); }
  .ad-spacer { height: calc(80px + env(safe-area-inset-bottom)); }

  /* FEUILLE DE CONFIRMATION / CREATION */
  .ad-ov { position: fixed; inset: 0; background: rgba(15,30,26,.55); z-index: 300; display: flex; align-items: flex-end; justify-content: center; }
  .ad-sheet { background: #fff; width: 100%; max-width: 520px; border-radius: 22px 22px 0 0; padding: 20px 20px calc(20px + env(safe-area-inset-bottom)); max-height: 92vh; overflow-y: auto; }
  .ad-sheet h3 { font-size: 19px; color: var(--g); margin: 0 0 8px; font-weight: 800; }
  .ad-sheet .ad-field { margin-top: 12px; } .ad-sheet label { font-size: 13px; font-weight: 600; color: var(--g); display: block; margin-bottom: 6px; }
  .ad-sheet .btns { display: grid; gap: 10px; margin-top: 18px; }
  .ad-toast { position: fixed; left: 16px; right: 16px; bottom: calc(92px + env(safe-area-inset-bottom)); background: var(--g); color: #fff; padding: 14px 16px; border-radius: 14px; font-size: 14.5px; font-weight: 600; z-index: 400; text-align: center; box-shadow: 0 8px 24px rgba(0,0,0,.2); }
  .ad-toast.error { background: #b8391a; }
  .ad-rep { display: grid; grid-template-columns: repeat(3, 1fr); gap: 8px; margin: 12px 0 4px; text-align: center; }
  .ad-rep div { background: var(--c); border-radius: 12px; padding: 10px 4px; } .ad-rep b { display: block; font-size: 22px; color: var(--g); } .ad-rep span { font-size: 11.5px; color: var(--mut); }

  /* ORDINATEUR : liste à gauche, fiche à droite */
  @media (min-width: 900px) {
    .ad-top { padding: 0 32px; }
    .ad-grid { display: grid; grid-template-columns: 380px 1fr; align-items: start; }
    .ad-pane.list { border-right: 1px solid var(--line); min-height: calc(100vh - 60px); }
    .ad-detail { display: block; position: static; inset: auto; overflow: visible; background: transparent; }
    .ad-detail.open { position: static; }
    .ad-d-top { display: none; }
    .ad-d-body { padding: 24px 32px 48px; margin: 0; }
    .ad-detail.empty .ad-empty { padding: 120px 20px; }
    .ad-fab { bottom: 96px; right: 28px; }
    .ad-bn { left: 50%; right: auto; transform: translateX(-50%); width: 480px; border-radius: 18px 18px 0 0; border: 1px solid var(--line); }
    .ad-toast { left: 50%; right: auto; transform: translateX(-50%); width: 360px; }
  }
`;

const ICONS = {
  users: <svg viewBox="0 0 24 24"><circle cx="9" cy="8" r="3.5" /><path d="M2.5 20c0-3.6 3-5.5 6.5-5.5s6.5 1.9 6.5 5.5" /><path d="M16 4.6a3.5 3.5 0 0 1 0 6.8M18 14.8c2.2.6 3.5 2.3 3.5 5.2" /></svg>,
  journal: <svg viewBox="0 0 24 24"><path d="M6 3h12v18H6z" /><path d="M9 8h6M9 12h6M9 16h4" /></svg>,
  tools: <svg viewBox="0 0 24 24"><path d="M14.7 6.3a4 4 0 0 0-5 5L3 18v3h3l6.7-6.7a4 4 0 0 0 5-5l-2.4 2.4-2.6-.6-.6-2.6z" /></svg>,
  msg: <svg viewBox="0 0 24 24"><path d="M4 5h16v11H9l-5 4z" /></svg>,
  cand: <svg viewBox="0 0 24 24"><path d="M20 6 9 17l-5-5" /></svg>,
  suivi: <svg viewBox="0 0 24 24"><path d="M4 20V10M10 20V4M16 20v-7M22 20H2" /></svg>,
  app: <svg viewBox="0 0 24 24"><rect x="7" y="2.5" width="10" height="19" rx="2.5" /><path d="M11 18.5h2" /></svg>,
};

const initials = (u) => `${(u.prenom || '?')[0]}${(u.nom || '')[0] || ''}`.toUpperCase();
const fmt = (d) => d ? new Date(d).toLocaleDateString('fr-FR') : '';
const isoDay = (d) => d.toISOString().split('T')[0];

function statutOf(u) {
  if (u.bloqueParAdmin || u.statut === 'Bloqué') return { k: 'bloque', l: 'Bloqué' };
  if (u.premiumDebloque || u.statut === 'Premium') return { k: 'premium', l: 'Premium' };
  if (u.statut === 'Expiré' || u.joursRestants === 0) return { k: 'expire', l: 'Expiré' };
  if (u.joursRestants > 0 && u.joursRestants <= 3) return { k: 'soon', l: `${u.joursRestants} j` };
  return { k: 'actif', l: 'Actif' };
}

const MODULE_LABELS = {
  1: 'Idée & Vision', 2: 'Persona client', 3: "Raison d'être", 4: 'Positionnement', 5: 'Personnalité et voix',
  8: 'Réseaux sociaux', 9: 'Acquisition', 10: 'Fidélisation', 11: 'Google Business', 12: 'Publicité Meta', 13: 'Premiers clients',
};

export function AdminPage() {
  const navigate = useNavigate();
  const { logout } = useAuth();
  const [tab, setTab] = useState('users');
  const [users, setUsers] = useState([]);
  const [journal, setJournal] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedEmail, setSelectedEmail] = useState(null);
  const [detail, setDetail] = useState(null);
  const [detailLoading, setDetailLoading] = useState(false);
  const [search, setSearch] = useState('');
  const [filter, setFilter] = useState('Tous');
  const [jFilter, setJFilter] = useState('Tout');
  const [extendDate, setExtendDate] = useState('');
  const [noteText, setNoteText] = useState('');
  const [toast, setToast] = useState(null);
  const [sheet, setSheet] = useState(null); // {title,text,input,confirmLabel,danger,onConfirm}
  const [sheetInput, setSheetInput] = useState('');
  const [showCreate, setShowCreate] = useState(false);
  const [newUser, setNewUser] = useState({ prenom: '', nom: '', email: '', password: '' });
  const [cleanupLoading, setCleanupLoading] = useState(false);
  const [cleanupReport, setCleanupReport] = useState(null);

  const showToast = (msg, type = 'ok') => { setToast({ msg, type }); setTimeout(() => setToast(null), 3200); };

  const loadUsers = async () => {
    try { const r = await api.adminGetUsers(); setUsers(r.users || []); }
    catch (e) { showToast(e.message, 'error'); }
  };
  const [suivi, setSuivi] = useState(null);
  const loadSuivi = async () => {
    try { setSuivi(await api.adminSuivi()); }
    catch (e) { showToast(e.message, 'error'); }
  };
  const [convs, setConvs] = useState(null);
  const [thread, setThread] = useState(null); // { email, prenom, messages, contexte }
  const [reply, setReply] = useState('');
  const loadConvs = async () => {
    try { setConvs(await api.adminMessages()); }
    catch (e) { showToast(e.message, 'error'); }
  };
  const openThread = async (c) => {
    try { const r = await api.adminThread(c.email); setThread({ email: c.email, prenom: c.prenom || c.email, ...r }); setReply(''); }
    catch (e) { showToast(e.message, 'error'); }
  };
  const sendReply = async () => {
    if (!reply.trim() || !thread) return;
    try { await api.adminReply(thread.email, reply.trim()); setReply(''); await openThread({ email: thread.email, prenom: thread.prenom }); showToast('Message envoyé.'); }
    catch (e) { showToast(e.message, 'error'); }
  };
  const [cands, setCands] = useState(null);
  const loadCands = async () => {
    try { setCands(await api.adminCandidatures()); }
    catch (e) { showToast(e.message, 'error'); }
  };
  const traiter = async (email, action) => {
    try { const r = await api.adminCandidature(email, action); showToast(r.message); await loadCands(); }
    catch (e) { showToast(e.message, 'error'); }
  };
  const loadJournal = async () => {
    try { const r = await api.adminJournal(); setJournal(r.journal || []); }
    catch (e) { showToast(e.message, 'error'); }
  };

  useEffect(() => {
    setLoading(true);
    (tab === 'journal' ? loadJournal() : tab === 'suivi' ? loadSuivi() : tab === 'cand' ? loadCands() : tab === 'msg' ? loadConvs() : loadUsers()).finally(() => setLoading(false));
    // eslint-disable-next-line
  }, [tab]);

  const selectUser = async (email) => {
    setSelectedEmail(email);
    setDetailLoading(true);
    setDetail(null);
    setExtendDate('');
    try { setDetail(await api.adminGetUser(email)); }
    catch (e) { showToast(e.message, 'error'); }
    finally { setDetailLoading(false); }
  };
  const closeDetail = () => { setSelectedEmail(null); setDetail(null); };

  const doAction = async (fn, msg, keep = true) => {
    try {
      await fn();
      showToast(msg);
      await loadUsers();
      if (keep && selectedEmail) await selectUser(selectedEmail);
    } catch (e) { showToast(e.message, 'error'); }
  };

  const ask = (cfg) => { setSheetInput(''); setSheet(cfg); };

  const baseDate = () => {
    const fin = detail?.user?.dateFinAcces ? new Date(detail.user.dateFinAcces) : null;
    const now = new Date();
    return fin && fin > now ? fin : now;
  };
  const quick = (days) => { const d = new Date(baseDate()); d.setDate(d.getDate() + days); setExtendDate(isoDay(d)); };
  const handleExtend = () => {
    if (!extendDate) return showToast('Choisis une date.', 'error');
    doAction(() => api.adminExtendDate(selectedEmail, extendDate), `Accès prolongé jusqu'au ${fmt(extendDate)}.`);
    setExtendDate('');
  };
  const handleNote = () => {
    if (!noteText.trim()) return;
    doAction(() => api.adminMessage(selectedEmail, noteText), 'Note enregistrée.');
    setNoteText('');
  };
  const handleCreate = async () => {
    try {
      await api.adminCreateUser(newUser);
      showToast('Compte créé.');
      setShowCreate(false);
      setNewUser({ prenom: '', nom: '', email: '', password: '' });
      await loadUsers();
    } catch (e) { showToast(e.message, 'error'); }
  };
  const runCleanup = async () => {
    setCleanupLoading(true);
    setCleanupReport(null);
    try {
      const res = await fetch('/api/admin/cleanup', { method: 'POST', headers: { Authorization: `Bearer ${localStorage.getItem('bs_token')}` } });
      const data = await res.json();
      setCleanupReport(data);
      showToast(data.message || 'Nettoyage terminé.');
      await loadUsers();
    } catch (e) { showToast(e.message, 'error'); }
    finally { setCleanupLoading(false); }
  };

  const stats = useMemo(() => ({
    total: users.length,
    actifs: users.filter(u => statutOf(u).k === 'actif' || statutOf(u).k === 'soon').length,
    premium: users.filter(u => statutOf(u).k === 'premium').length,
    soon: users.filter(u => statutOf(u).k === 'soon').length,
  }), [users]);

  const FILTERS = ['Tous', 'Actifs', 'Premium', 'Expirés', 'Bloqués'];
  const filtered = users.filter(u => {
    const s = statutOf(u).k;
    const okSearch = !search || `${u.prenom} ${u.nom} ${u.email}`.toLowerCase().includes(search.toLowerCase());
    const okFilter = filter === 'Tous' || (filter === 'Actifs' && (s === 'actif' || s === 'soon')) || (filter === 'Premium' && s === 'premium')
      || (filter === 'Expirés' && s === 'expire') || (filter === 'Bloqués' && s === 'bloque');
    return okSearch && okFilter;
  });

  const jTypes = ['Tout', ...Array.from(new Set(journal.map(j => j.typeAction).filter(Boolean))).slice(0, 5)];
  const jFiltered = journal.filter(j => jFilter === 'Tout' || j.typeAction === jFilter);
  const dayLabel = (d) => {
    if (!d) return 'Date inconnue';
    const x = new Date(d); const t = new Date();
    const same = (a, b) => a.toDateString() === b.toDateString();
    const y = new Date(); y.setDate(t.getDate() - 1);
    return same(x, t) ? "Aujourd'hui" : same(x, y) ? 'Hier' : x.toLocaleDateString('fr-FR', { day: 'numeric', month: 'long', year: 'numeric' });
  };
  const jGroups = jFiltered.reduce((acc, j) => { const k = dayLabel(j.dateAction); (acc[k] = acc[k] || []).push(j); return acc; }, {});

  const du = detail?.user;
  const dst = du ? statutOf(du) : null;
  const bloque = du && (du.bloqueParAdmin || du.statut === 'Bloqué');

  return (
    <div className="ad">
      <style>{css}</style>
      {toast && <div className={`ad-toast${toast.type === 'error' ? ' error' : ''}`}>{toast.msg}</div>}

      <header className="ad-top">
        <img src={logo} alt="BrandStarter" />
        <span className="ad-pill-admin">ADMIN</span>
      </header>

      {/* ───────── UTILISATEURS ───────── */}
      {tab === 'users' && (
        <div className="ad-grid">
          <div className="ad-pane list">
            <h1 className="ad-h2">Utilisateurs</h1>
            <div className="ad-kpis">
              <div className="ad-card ad-kpi"><b>{stats.total}</b><span>Inscrits</span></div>
              <div className="ad-card ad-kpi"><b>{stats.actifs}</b><span>Actifs</span></div>
              <div className="ad-card ad-kpi"><b>{stats.premium}</b><span>Premium</span></div>
              <div className="ad-card ad-kpi hot"><b>{stats.soon}</b><span>Expirent sous 3 jours</span></div>
            </div>
            <input className="ad-search" placeholder="Rechercher un nom ou un e-mail" value={search} onChange={e => setSearch(e.target.value)} />
            <div className="ad-chips">
              {FILTERS.map(f => <button key={f} className={`ad-chip${filter === f ? ' on' : ''}`} onClick={() => setFilter(f)}>{f}</button>)}
            </div>
            <div className="ad-list">
              {loading ? <div className="ad-empty"><Spinner /></div>
                : filtered.length === 0 ? <div className="ad-empty">Aucun utilisateur trouvé.</div>
                : filtered.map(u => {
                  const s = statutOf(u);
                  const pct = s.k === 'premium' ? 100 : Math.max(4, Math.min(100, 100 - (u.joursRestants / 20) * 100));
                  return (
                    <button key={u.email} className={`ad-card ad-u${selectedEmail === u.email ? ' sel' : ''}`} onClick={() => selectUser(u.email)}>
                      <div className={`ad-ini${s.k === 'premium' ? ' prem' : s.k === 'expire' || s.k === 'bloque' ? ' off' : ''}`}>{initials(u)}</div>
                      <div className="ad-u-body">
                        <div className="ad-u-row"><span className="ad-u-name">{u.prenom} {u.nom}</span><span className={`ad-st ${s.k}`}>{s.l}</span></div>
                        <div className="ad-u-meta">Module {u.moduleActuel} · {s.k === 'premium' ? 'accès premium' : `${u.joursRestants} jours restants`}</div>
                        <div className="ad-bar"><i style={{ width: `${pct}%`, background: s.k === 'premium' ? '#173B34' : undefined }} /></div>
                      </div>
                    </button>
                  );
                })}
            </div>
          </div>

          {/* FICHE */}
          <div className={`ad-detail${selectedEmail ? ' open' : ' empty'}`}>
            <div className="ad-d-top">
              <button className="ad-back" onClick={closeDetail} aria-label="Retour">←</button>
              <span className="ad-d-title">{du ? `${du.prenom} ${du.nom}` : 'Fiche'}</span>
            </div>
            {!selectedEmail ? <div className="ad-empty">Choisis un utilisateur pour voir sa fiche.</div>
              : detailLoading || !du ? <div className="ad-empty"><Spinner size={32} /></div>
              : (
                <div className="ad-d-body">
                  <div className="ad-card ad-id">
                    <div className={`ad-ini${dst.k === 'premium' ? ' prem' : ''}`}>{initials(du)}</div>
                    <div>
                      <b style={{ fontSize: 18 }}>{du.prenom} {du.nom}</b>
                      <div className="ad-mail">{du.email}</div>
                      <span className={`ad-st ${dst.k}`}>{dst.l}</span>
                    </div>
                  </div>

                  <div className="ad-sec">Aperçu</div>
                  <div className="ad-row2">
                    <div className="ad-stat"><b>{fmt(du.dateInscription) || 'n.c.'}</b><span>Inscription</span></div>
                    <div className="ad-stat"><b>{du.joursRestants} j</b><span>Jours restants</span></div>
                    <div className="ad-stat"><b>{detail.progression?.modulesCompletes ?? 0} / 5</b><span>Modules complétés</span></div>
                    <div className="ad-stat"><b>Module {du.moduleActuel}</b><span>Module actuel</span></div>
                  </div>

                  <div className="ad-sec">Accès</div>
                  <div className="ad-card">
                    <p className="ad-small">Fin d'accès actuelle : <b>{du.dateFinAcces ? fmt(du.dateFinAcces) : 'selon la date d\'inscription'}</b></p>
                    <input className="ad-in" type="date" value={extendDate} min={isoDay(new Date())} onChange={e => setExtendDate(e.target.value)} />
                    <div className="ad-qk">
                      <button className="ad-chip" onClick={() => quick(7)}>+7 jours</button>
                      <button className="ad-chip" onClick={() => quick(30)}>+30 jours</button>
                      <button className="ad-chip" onClick={() => quick(365)}>+1 an</button>
                    </div>
                    <button className="ad-btn green" onClick={handleExtend}>Prolonger l'accès</button>
                  </div>

                  <div className="ad-sec">Actions rapides</div>
                  <div className="ad-row2">
                    {du.premiumDebloque
                      ? <button className="ad-btn ghost" onClick={() => doAction(() => api.adminRevokePremium(selectedEmail), 'Premium retiré.')}>Retirer Premium</button>
                      : <button className="ad-btn pri" onClick={() => doAction(() => api.adminPremium(selectedEmail), 'Premium activé.')}>Passer Premium</button>}
                    {bloque
                      ? <button className="ad-btn ghost" onClick={() => doAction(() => api.adminUnblock(selectedEmail), 'Utilisateur débloqué.')}>Débloquer</button>
                      : <button className="ad-btn ghost" onClick={() => ask({
                          title: 'Bloquer cet utilisateur ?', text: "Il ne pourra plus accéder à l'application.", input: 'Raison du blocage (facultatif)', confirmLabel: 'Bloquer', danger: true,
                          onConfirm: (note) => doAction(() => api.adminBlock(selectedEmail, note || ''), 'Utilisateur bloqué.'),
                        })}>Bloquer</button>}
                  </div>

                  <div className="ad-sec">Note ou message</div>
                  <textarea className="ad-in" value={noteText} onChange={e => setNoteText(e.target.value)} placeholder={`Écris une note pour ${du.prenom}`} />
                  <button className="ad-btn ghost" style={{ marginTop: 10 }} onClick={handleNote}>Enregistrer la note</button>

                  {detail.responses?.length > 0 && (
                    <>
                      <div className="ad-sec">Contenu validé par l'utilisateur</div>
                      {detail.responses.map((r, i) => (
                        <div key={i} className="ad-resp"><b>{MODULE_LABELS[r.numeroModule] || r.nomModule}</b><p>{r.contenu}</p></div>
                      ))}
                    </>
                  )}

                  <div className="ad-sec">Zone sensible</div>
                  <button className="ad-btn red" onClick={() => ask({
                    title: 'Supprimer ce compte ?', text: `Le compte de ${selectedEmail} sera supprimé définitivement.`, confirmLabel: 'Supprimer', danger: true,
                    onConfirm: () => { doAction(() => api.adminDelete(selectedEmail), 'Compte supprimé.', false); closeDetail(); },
                  })}>Supprimer ce compte</button>
                  <p className="ad-small" style={{ marginTop: 8 }}>Une confirmation te sera demandée.</p>
                </div>
              )}
          </div>
          <button className="ad-fab" onClick={() => setShowCreate(true)}>+ Créer un compte</button>
        </div>
      )}

      {/* ───────── JOURNAL ───────── */}
      {tab === 'journal' && (
        <div className="ad-pane" style={{ maxWidth: 680, margin: '0 auto' }}>
          <h1 className="ad-h2">Journal d'activité</h1>
          <div className="ad-chips">
            {jTypes.map(t => <button key={t} className={`ad-chip${jFilter === t ? ' on' : ''}`} onClick={() => setJFilter(t)}>{t}</button>)}
          </div>
          {loading ? <div className="ad-empty"><Spinner /></div>
            : jFiltered.length === 0 ? <div className="ad-empty">Aucune activité.</div>
            : Object.entries(jGroups).map(([day, items]) => (
              <div key={day}>
                <div className="ad-sec">{day}</div>
                {items.map((j, i) => (
                  <div key={i} className="ad-ev">
                    <div className="ad-dot" />
                    <div><b>{j.action || j.typeAction}</b><p>{j.emailUtilisateur}{j.typeAction ? ` · ${j.typeAction}` : ''}</p>{j.note && <em>{j.note}</em>}</div>
                  </div>
                ))}
              </div>
            ))}
        </div>
      )}

      {/* ───────── MESSAGES ───────── */}
      {tab === 'msg' && (
        <div className="ad-pane" style={{ maxWidth: 680, margin: '0 auto' }}>
          {thread ? (
            <>
              <button className="ad-btn ghost" style={{ width: 'auto', minHeight: 40, marginBottom: 10 }} onClick={() => { setThread(null); loadConvs(); }}>← Messages</button>
              <h1 className="ad-h2">{thread.prenom}</h1>
              {thread.contexte && <div style={{ background: '#E6F2EC', borderRadius: 10, padding: '8px 12px', fontSize: 12.5, color: '#173B34', marginBottom: 10 }}>Module {thread.contexte.moduleActuel} · {thread.contexte.joursRestants} jours restants{thread.contexte.projet ? ' · ' + thread.contexte.projet : ''}</div>}
              <div style={{ display: 'flex', flexDirection: 'column', gap: 8, margin: '8px 0 14px' }}>
                {thread.messages.length === 0 && <div className="ad-empty">Aucun message.</div>}
                {thread.messages.map(m => (
                  <div key={m.id} style={{ alignSelf: m.from === 'admin' ? 'flex-end' : 'flex-start', maxWidth: '84%', background: m.from === 'admin' ? '#173B34' : '#fff', color: m.from === 'admin' ? '#fff' : '#222', border: '1px solid #E3DCCF', borderRadius: 14, padding: '9px 12px', fontSize: 14.5, lineHeight: 1.45, whiteSpace: 'pre-wrap' }}>
                    {m.text}<div style={{ fontSize: 11, opacity: .6, marginTop: 3 }}>{new Date(m.date).toLocaleString('fr-FR', { day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit' })}</div>
                  </div>
                ))}
              </div>
              <textarea value={reply} onChange={e => setReply(e.target.value)} placeholder={`Ta réponse à ${thread.prenom}...`} rows={3}
                style={{ width: '100%', border: '1.5px solid #E3DCCF', borderRadius: 14, padding: 12, fontSize: 16, fontFamily: 'inherit', marginBottom: 8 }} />
              <button className="ad-btn pri" onClick={sendReply} disabled={!reply.trim()}>Envoyer</button>
            </>
          ) : (
            <>
              <h1 className="ad-h2">Messages</h1>
              {loading || !convs ? <div className="ad-empty"><Spinner /></div> : (
                <>
                  <div className="ad-sec">{convs.aRepondre} à répondre</div>
                  {convs.conversations.length === 0 ? <div className="ad-empty">Aucune conversation pour le moment.</div> : convs.conversations.map(c => (
                    <div key={c.email} className="ad-card" onClick={() => openThread(c)} style={{ marginBottom: 8, cursor: 'pointer', borderColor: c.nonLus ? '#E4572E' : undefined }}>
                      <div style={{ display: 'flex', justifyContent: 'space-between', gap: 8 }}>
                        <b>{c.prenom || c.email} {c.nom}</b>
                        <span style={{ fontSize: 12, color: '#6b6b64' }}>{new Date(c.dernier.date).toLocaleDateString('fr-FR', { day: 'numeric', month: 'short' })}{c.nonLus ? <b style={{ background: '#E4572E', color: '#fff', borderRadius: 9, padding: '1px 7px', marginLeft: 6 }}>{c.nonLus}</b> : null}</span>
                      </div>
                      <div style={{ fontSize: 13.5, color: '#555', marginTop: 3, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{c.dernier.from === 'admin' ? 'Vous : ' : ''}{c.dernier.text}</div>
                    </div>
                  ))}
                </>
              )}
            </>
          )}
        </div>
      )}

      {/* ───────── CANDIDATURES ───────── */}
      {tab === 'cand' && (
        <div className="ad-pane" style={{ maxWidth: 680, margin: '0 auto' }}>
          <h1 className="ad-h2">Candidatures</h1>
          {loading || !cands ? <div className="ad-empty"><Spinner /></div> : (
            <>
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3,1fr)', gap: 8, marginTop: 8 }}>
                <div className="ad-stat"><b>{cands.attente.length}</b><span>À traiter</span></div>
                <div className="ad-stat"><b>{cands.attente.filter(c => (Date.now() - new Date(c.depuis)) / 36e5 > 48).length}</b><span>Plus de 48 h</span></div>
                <div className="ad-stat"><b>{cands.valides}/{cands.max}</b><span>Places prises</span></div>
              </div>
              <div className="ad-sec">À traiter</div>
              {cands.attente.length === 0 ? <div className="ad-empty">Aucune candidature en attente.</div> : cands.attente.map(c => {
                const h = Math.floor((Date.now() - new Date(c.depuis)) / 36e5);
                const retard = h > 48;
                return (
                  <div key={c.email} className="ad-card" style={{ marginBottom: 10 }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', gap: 8 }}>
                      <div><b>{c.prenom} {c.nom}</b><div style={{ fontSize: 12.5, color: '#6b6b64' }}>{c.email}{c.source ? ' · ' + c.source : ''}</div></div>
                      <span style={{ fontSize: 12, fontWeight: 700, color: retard ? '#b8391a' : '#8A5B00', whiteSpace: 'nowrap' }}>{retard ? 'En retard' : 'Depuis ' + (c.depuis || '').slice(0, 10)}</span>
                    </div>
                    <div style={{ background: '#F6F2EC', borderRadius: 10, padding: '8px 10px', margin: '10px 0', fontSize: 13.5, lineHeight: 1.5 }}>
                      <b>Stade :</b> {c.stade || 'n/a'}<br /><b>Projet :</b> {c.projet || 'n/a'}
                    </div>
                    <div style={{ display: 'flex', gap: 8 }}>
                      <button className="ad-btn green" onClick={() => traiter(c.email, 'valider')}>Valider</button>
                      <button className="ad-btn red" onClick={() => traiter(c.email, 'refuser')}>Refuser</button>
                    </div>
                    <a style={{ display: 'block', textAlign: 'center', fontSize: 13, marginTop: 8, color: '#173B34', fontWeight: 700 }}
                       href={`mailto:${c.email}?subject=${encodeURIComponent('Ton accès à BrandStarter est activé')}&body=${encodeURIComponent(`Bonjour ${c.prenom},\n\nJ'ai étudié ta demande et je suis heureux de t'accueillir sur BrandStarter. Ton compte est activé et tes 20 jours d'accès gratuit démarrent dès aujourd'hui.\n\nConnecte-toi ici : https://brandstarter.fr/connexion\n\nDany, fondateur de BrandStarter`)}`}>
                      Écrire à {c.prenom} (message d'activation)
                    </a>
                  </div>
                );
              })}
              {cands.refuses.length > 0 && <div className="ad-sec">Refusées ({cands.refuses.length})</div>}
              {cands.refuses.map(c => <div key={c.email} className="ad-card" style={{ marginBottom: 8, fontSize: 13.5 }}>{c.prenom} · {c.email}</div>)}
            </>
          )}
        </div>
      )}

      {/* ───────── SUIVI ───────── */}
      {tab === 'suivi' && (
        <div className="ad-pane" style={{ maxWidth: 680, margin: '0 auto' }}>
          <h1 className="ad-h2">Suivi</h1>
          {loading || !suivi ? <div className="ad-empty"><Spinner /></div> : (() => {
            const u = suivi.usage, a = u.aujourdhui;
            const eur = (n) => `${n.toFixed(n < 1 ? 3 : 2).replace('.', ',')} €`;
            const maxCalls = Math.max(1, ...u.jours.map(j => j.calls));
            return (
              <>
                <div className="ad-sec">Consommation IA aujourd'hui</div>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10 }}>
                  <div className="ad-stat"><b>{a.calls}</b><span>Appels à Clara</span></div>
                  <div className="ad-stat"><b>{eur(a.coutEur)}</b><span>Coût estimé</span></div>
                  <div className="ad-stat"><b>{a.users}</b><span>Utilisateurs actifs</span></div>
                  <div className="ad-stat"><b>{Math.round((a.tin + a.tout) / 1000)} k</b><span>Tokens utilisés</span></div>
                </div>
                <div className="ad-sec">14 derniers jours</div>
                <div className="ad-card">
                  {u.jours.length === 0 ? <div className="ad-empty">Pas encore de données.</div> : u.jours.map(j => (
                    <div key={j.day} style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '6px 0', fontSize: 13 }}>
                      <span style={{ width: 52, color: '#6b6b64' }}>{fmt(j.day).slice(0, 5)}</span>
                      <div style={{ flex: 1, background: '#EAF1EE', borderRadius: 99, height: 10, overflow: 'hidden' }}><div style={{ width: `${(j.calls / maxCalls) * 100}%`, height: '100%', background: '#E4572E' }} /></div>
                      <span style={{ width: 92, textAlign: 'right' }}>{j.calls} · {eur(j.coutEur)}</span>
                    </div>
                  ))}
                  <p style={{ fontSize: 12.5, color: '#6b6b64', margin: '10px 0 0' }}>Moyenne : {eur(u.moyenneEur)} par jour sur la période. Estimation basée sur les tarifs indicatifs : {u.hypotheses.prixInUsd} $ par million de tokens en entrée, {u.hypotheses.prixOutUsd} $ en sortie.</p>
                </div>
                <div className="ad-sec">Appels par module aujourd'hui</div>
                <div className="ad-card">
                  {Object.keys(a.mods || {}).length === 0 ? <div className="ad-empty">Aucun appel aujourd'hui.</div> : Object.entries(a.mods).sort((x, y) => y[1] - x[1]).map(([n, c]) => (
                    <div key={n} style={{ display: 'flex', justifyContent: 'space-between', padding: '6px 0', fontSize: 14 }}><span>{MODULE_LABELS[n] || `Module ${n}`}</span><b>{c}</b></div>
                  ))}
                </div>
                <div className="ad-sec">Tentatives suspectes (24 h)</div>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10 }}>
                  <div className="ad-stat"><b>{suivi.resume?.echecs || 0}</b><span>Mots de passe faux</span></div>
                  <div className="ad-stat"><b>{suivi.resume?.bloques || 0}</b><span>Comptes bloqués</span></div>
                  <div className="ad-stat"><b>{suivi.resume?.robots || 0}</b><span>Inscriptions de robots</span></div>
                  <div className="ad-stat"><b>{suivi.resume?.limiteIp || 0}</b><span>Blocages par IP</span></div>
                </div>
                <div className="ad-card" style={{ marginTop: 10 }}>
                  {(suivi.evenements || []).length === 0 ? <div className="ad-empty">Rien de suspect depuis le dernier redémarrage.</div> : suivi.evenements.map((e, i) => {
                    const L = { echec_connexion: 'Mot de passe faux', connexion_bloquee: 'Tentative sur compte bloqué', compte_verrouille: 'Compte verrouillé', inscription_robot: 'Robot à l\'inscription', limite_ip: 'IP bloquée' }[e.type] || e.type;
                    const grave = e.type !== 'echec_connexion';
                    return (
                      <div key={i} style={{ padding: '8px 0', borderBottom: '1px solid #F0EBE3', fontSize: 13.5 }}>
                        <b style={{ color: grave ? '#9b2c1f' : '#173B34' }}>{L}</b>
                        <div style={{ color: '#6b6b64', wordBreak: 'break-all' }}>{e.email || 'sans e-mail'} · IP {e.ip || '?'}</div>
                        <div style={{ color: '#8a8a82', fontSize: 12 }}>{new Date(e.date).toLocaleString('fr-FR')}</div>
                      </div>
                    );
                  })}
                </div>
                {suivi.erreurs && suivi.erreurs.length > 0 && <div className="ad-empty" style={{ color: '#9b2c1f' }}>Données indisponibles : {suivi.erreurs.join(', ')}.</div>}
                <div className="ad-sec">Comptes verrouillés en ce moment</div>
                <div className="ad-card">
                  {suivi.verrous.length === 0 ? <div className="ad-empty">Aucun compte verrouillé.</div> : suivi.verrous.map((v, i) => (
                    <div key={i} style={{ display: 'flex', justifyContent: 'space-between', gap: 10, padding: '7px 0', fontSize: 14 }}>
                      <span style={{ wordBreak: 'break-all' }}>{v.email}</span>
                      <b style={{ color: v.minutes ? '#9b2c1f' : '#6b6b64', whiteSpace: 'nowrap' }}>{v.minutes ? `${v.minutes} min` : `${v.echecs} échec${v.echecs > 1 ? 's' : ''}`}</b>
                    </div>
                  ))}
                </div>
                <div className="ad-sec">Derniers verrouillages</div>
                {suivi.historique.length === 0 ? <div className="ad-empty">Aucun historique.</div> : suivi.historique.map((h, i) => (
                  <div key={i} className="ad-ev"><div className="ad-dot" /><div><b>{h.email}</b><p>{fmt(h.date)}</p></div></div>
                ))}
                <p style={{ fontSize: 12.5, color: '#6b6b64', marginTop: 16 }}>La liste des comptes verrouillés en ce moment est remise à zéro à chaque redémarrage de l'app.</p>
              </>
            );
          })()}
        </div>
      )}

      {/* ───────── OUTILS ───────── */}
      {tab === 'tools' && (
        <div className="ad-pane" style={{ maxWidth: 560, margin: '0 auto' }}>
          <h1 className="ad-h2">Outils</h1>
          <div className="ad-card" style={{ marginBottom: 12 }}>
            <b>Nettoyage RGPD</b>
            <p className="ad-small" style={{ margin: '6px 0 12px' }}>Supprime définitivement les comptes expirés depuis plus de 30 jours. Les comptes admin et premium sont protégés.</p>
            <button className="ad-btn green" disabled={cleanupLoading} onClick={() => ask({
              title: 'Lancer le nettoyage RGPD ?', text: 'Les comptes expirés depuis plus de 30 jours seront supprimés définitivement. Les comptes admin et premium sont protégés.',
              confirmLabel: 'Lancer le nettoyage', danger: true, onConfirm: runCleanup,
            })}>{cleanupLoading ? 'Nettoyage en cours...' : 'Lancer le nettoyage'}</button>
            {cleanupReport && (
              <>
                <div className="ad-rep">
                  <div><b>{cleanupReport.report?.analysed || 0}</b><span>Analysés</span></div>
                  <div><b style={{ color: '#b8391a' }}>{cleanupReport.report?.deleted?.length || 0}</b><span>Supprimés</span></div>
                  <div><b>{cleanupReport.report?.skipped?.length || 0}</b><span>Conservés</span></div>
                </div>
                {cleanupReport.report?.deleted?.length > 0 && (
                  <p className="ad-small">Supprimés : {cleanupReport.report.deleted.map(d => `${d.email} (${d.expiredSince} j)`).join(', ')}</p>
                )}
                {cleanupReport.report?.errors?.length > 0 && (
                  <p className="ad-small" style={{ color: '#b8391a' }}>Erreurs : {cleanupReport.report.errors.map(e => e.email).join(', ')}</p>
                )}
              </>
            )}
          </div>
          <div className="ad-card" style={{ marginBottom: 12 }}>
            <b>Créer un compte</b>
            <p className="ad-small" style={{ margin: '6px 0 12px' }}>Pour un testeur ou une personne que tu accompagnes.</p>
            <button className="ad-btn ghost" onClick={() => setShowCreate(true)}>Créer un compte</button>
          </div>
          <div className="ad-card" style={{ marginBottom: 12 }}>
            <b>Voir l'application</b>
            <p className="ad-small" style={{ margin: '6px 0 12px' }}>Ouvre le parcours comme un utilisateur.</p>
            <button className="ad-btn ghost" onClick={() => navigate('/parcours')}>Ouvrir le parcours</button>
          </div>
          <button className="ad-btn red" onClick={() => { logout(); navigate('/connexion'); }}>Déconnexion</button>
        </div>
      )}

      <div className="ad-spacer" />

      <nav className="ad-bn" aria-label="Navigation admin">
        <button className={tab === 'users' ? 'on' : ''} onClick={() => setTab('users')}>{ICONS.users}Utilisateurs</button>
        <button className={tab === 'journal' ? 'on' : ''} onClick={() => setTab('journal')}>{ICONS.journal}Journal</button>
        <button className={tab === 'msg' ? 'on' : ''} onClick={() => { setThread(null); setTab('msg'); }}>{ICONS.msg}Messages</button>
        <button className={tab === 'cand' ? 'on' : ''} onClick={() => setTab('cand')}>{ICONS.cand}Candidatures</button>
        <button className={tab === 'suivi' ? 'on' : ''} onClick={() => setTab('suivi')}>{ICONS.suivi}Suivi</button>
        <button className={tab === 'tools' ? 'on' : ''} onClick={() => setTab('tools')}>{ICONS.tools}Outils</button>
        <button onClick={() => navigate('/parcours')}>{ICONS.app}L'app</button>
      </nav>

      {/* FEUILLE DE CONFIRMATION */}
      {sheet && (
        <div className="ad-ov" onClick={() => setSheet(null)}>
          <div className="ad-sheet" onClick={e => e.stopPropagation()}>
            <h3>{sheet.title}</h3>
            <p className="ad-small" style={{ fontSize: 14.5 }}>{sheet.text}</p>
            {sheet.input && (
              <div className="ad-field"><input className="ad-in" placeholder={sheet.input} value={sheetInput} onChange={e => setSheetInput(e.target.value)} /></div>
            )}
            <div className="btns">
              <button className={`ad-btn ${sheet.danger ? 'pri' : 'green'}`} onClick={() => { const s = sheet; setSheet(null); s.onConfirm(sheetInput); }}>{sheet.confirmLabel}</button>
              <button className="ad-btn ghost" onClick={() => setSheet(null)}>Annuler</button>
            </div>
          </div>
        </div>
      )}

      {/* CRÉER UN COMPTE */}
      {showCreate && (
        <div className="ad-ov" onClick={() => setShowCreate(false)}>
          <div className="ad-sheet" onClick={e => e.stopPropagation()}>
            <h3>Créer un compte</h3>
            {[
              { f: 'prenom', l: 'Prénom', t: 'text' }, { f: 'nom', l: 'Nom', t: 'text' },
              { f: 'email', l: 'Adresse e-mail', t: 'email' }, { f: 'password', l: 'Mot de passe', t: 'password' },
            ].map(({ f, l, t }) => (
              <div key={f} className="ad-field">
                <label>{l}</label>
                <input className="ad-in" type={t} value={newUser[f]} onChange={e => setNewUser(p => ({ ...p, [f]: e.target.value }))} />
              </div>
            ))}
            <div className="btns">
              <button className="ad-btn green" onClick={handleCreate}>Créer le compte</button>
              <button className="ad-btn ghost" onClick={() => setShowCreate(false)}>Annuler</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
